// ImageAttachments.jsx
import React from 'react';
import './ImageAttachments.scss';

const ImageAttachments = ({ attachments }) => {
  // If no attachments or empty array, return null
  if (!Array.isArray(attachments) || attachments.length === 0) {
    return null;
  }

  // Single image case
  if (attachments.length === 1) {
    return (
      <div className='image-attachments single'>
        <img src={attachments[0]} alt='' className='image-attachments__single-img' />
      </div>
    );
  }

  // Multiple images case (2-4 images typically like Twitter)
  return (
    <div className={`image-attachments grid images-${attachments.length}`}>
      {attachments.map((img, idx) => (
        <div key={`image_attachments_${idx}`} className='image-attachments__grid-item'>
          <img src={img} alt='' className='image-attachments__grid-img' />
        </div>
      ))}
    </div>
  );
};

export default ImageAttachments;
